import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { initializeBranch } from './Config/DeepLinks/deeplinks.config'
import { initializeSentry } from './Config/Sentry/sentry'

declare global {
  interface Window {
    google: any
    adsbygoogle: any
    bc: any
    firebase?: any
    branch?: any
    isBranchInitialized?: boolean
    gtag?: (...args: unknown[]) => void
  }
}

const initializeApp = async (): Promise<void> => {
  const container = document.getElementById('pll-web')

  if (!container) {
    console.warn('PLL Custom Web container not found - app will not render on this page')
    return
  }

  try {
    const { initFirebase } = await import(
      /* webpackChunkName: "firebase-init" */ './Api/firebase'
    )
    initFirebase()
  } catch (error) {
    console.warn('Firebase initialization failed:', error)
  }

  initializeBranch()
  initializeSentry().catch((err) => {
    console.error('Failed to initialize Sentry:', err)
  })

  container.className += ' pll-web-app'

  const root = createRoot(container)
  root.render(<App />)
}

initializeApp()
